import type { RouteRecordRaw } from "vue-router"

export const talentRoutes: RouteRecordRaw[] = [
    {
        path: "/talent",
        component: () => import("@/layouts/AuthLayout.vue"),
        meta: { guest: true },
        children: [
            {
                path: "login",
                name: "talent-login",
                component: () => import("@/pages/talent/Login.vue"),
                meta: { title: "Login" },
            },
            {
                path: "register",
                name: "talent-register",
                component: () => import("@/pages/talent/Register.vue"),
                meta: { title: "Register" },
            },
        ],
    },
    {
        path: "/talent/auth/google/callback",
        name: "talent-google-callback",
        component: () => import("@/pages/talent/GoogleCallback.vue"),
        meta: { skipAuthInit: true, skipVerification: true },
    },
    {
        path: "/talent",
        component: () => import("@/layouts/talent/TalentLayout.vue"),
        meta: { requiresAuth: true, requiresRole: "talent" },
        children: [
            {
                path: "dashboard",
                name: "talent-dashboard",
                component: () => import("@/pages/talent/Dashboard.vue"),
                meta: { title: "Dashboard" },
            },
            {
                path: "profile/edit",
                name: "talent-profile-edit",
                component: () => import("@/pages/talent/profile/ProfileEditView.vue"),
                meta: { title: "Edit Profile" },
            },
            // The standalone profile view and the per-section edit routes were
            // folded into the single tabbed ProfileEditView. Existing bookmarks,
            // emails and push notifications still point at the old paths, so
            // redirect rather than 404 them.
            {
                path: "profile",
                redirect: { name: "talent-profile-edit" },
            },
            {
                path: "profile/onboarding",
                redirect: { name: "talent-profile-edit" },
            },
            {
                path: "profile/edit/about-me",
                redirect: { name: "talent-profile-edit", query: { tab: "about-me" } },
            },
            {
                path: "profile/edit/education-certificate",
                redirect: { name: "talent-profile-edit", query: { tab: "education-certificate" } },
            },
            {
                path: "profile/edit/skills-experience",
                redirect: { name: "talent-profile-edit", query: { tab: "experience-skills" } },
            },
            // My Connections is gone: care centres unlock talents themselves
            // now, so there is nothing for a talent to approve.
            {
                path: "connections",
                redirect: { name: "talent-dashboard" },
            },
            {
                path: "learning",
                name: "talent-learning",
                component: () => import("@/pages/talent/learning/MyLearningPage.vue"),
                meta: { title: "My Learning" },
            },
            {
                path: "job-board",
                name: "talent-job-board",
                component: () => import("@/pages/talent/job-board/JobBoard.vue"),
                meta: { title: "Job Board", requiresJobBoard: true },
            },
            {
                path: "job-application",
                name: "talent-job-application",
                component: () => import("@/pages/talent/job-application/MyApplication.vue"),
                meta: { title: "My Application", requiresJobBoard: true },
            },
            {
                path: "account",
                name: "talent-account",
                component: () => import("@/pages/talent/Account.vue"),
                meta: { skipVerification: true, title: "Account" },
            },
            {
                path: "help",
                name: "talent-help",
                component: () => import("@/pages/talent/Help.vue"),
                meta: { skipVerification: true, title: "Help" },
            },
            {
                path: "notifications",
                name: "talent-notifications",
                component: () => import("@/pages/talent/Notifications.vue"),
                meta: { title: "Notifications" },
            },
            {
                path: ":pathMatch(.*)*",
                name: "talent-not-found",
                component: () => import("@/pages/talent/NotFound.vue"),
                meta: { title: "Not Found" },
            },
        ],
    },
]
